// extracted by mini-css-extract-plugin
export var formContainer = "_me-0";
export var message = "_me-1";